import { useThemeStore } from "../stores/theme";
import { useChaosStore } from "../stores/chaos";
import { removeAllLocalData } from "../utils/localDb";
import { useApiModeStore } from "../stores/apiMode";

function ThemeToggle() {
  const { theme, setTheme, toggleTheme } = useThemeStore();

  return (
    <div className="flex items-center gap-2">
      <button
        onClick={toggleTheme}
        className="p-2 bg-gray-100 dark:bg-gray-700 rounded"
      >
        {theme === 'light' ? 'Switch to Dark Mode' : 'Switch to Light Mode'}
      </button>
      <button
        onClick={() => setTheme('system')}
        className="p-2 bg-gray-100 dark:bg-gray-700 rounded"
      >
        Use System Default
      </button>
    </div>
  );
}

function ChaosToggle() {
  const { mode, setChaosMode } = useChaosStore();

  return (
    <div className="flex items-center gap-2">
      <select
        value={mode}
        onChange={(e) => setChaosMode(e.target.value as any)}
        className="p-2 bg-gray-100 dark:bg-gray-700 rounded"
      >
        <option value="disabled">Disabled</option>
        <option value="low">Low</option>
        <option value="medium">Medium</option>
        <option value="high">High</option>
      </select>
    </div>
  );
}

function ApiModeToggle() {
  const { apiMode, setApiMode } = useApiModeStore();
  return (
    <div className="flex items-center gap-2">
      <select
        value={apiMode}
        onChange={(e) => setApiMode(e.target.value as any)}
        className="p-2 bg-gray-100 dark:bg-gray-700 rounded"
      >
        <option value="local">Local</option>
        <option value="global">Global</option>
      </select>
    </div>
  );
}

const Settings = () => {
  const handleDeleteLocalData = async () => {
    await removeAllLocalData();
  };

  return (
    <div className="space-y-4">
      <div>
        <strong>Theme</strong>
        <ThemeToggle />
      </div>
      <div>
        <strong>Chaos</strong>
        <ChaosToggle />
      </div>
      <div>
        <strong>API Mode</strong>
        <ApiModeToggle />
      </div>
      <button
        onClick={handleDeleteLocalData}
        className="p-2 bg-red-600 text-white rounded"
      >
        Delete All Local Data
      </button>
    </div>
  );
};

export default Settings;